import { render, staticRenderFns } from "./PosterTextAdmin.vue?vue&type=template&id=6c89e5a2&scoped=true&"
import script from "./PosterTextAdmin.vue?vue&type=script&lang=js&"
export * from "./PosterTextAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PosterTextAdmin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PosterTextAdmin.vue?vue&type=style&index=1&id=6c89e5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c89e5a2",
  null
  
)

export default component.exports